// extracted by mini-css-extract-plugin
module.exports = {"main":"jut__Main__main","container":"jut__Main__container"};